import { instance as axios, setJwtToken } from "../../config/axiosInstance";

const BASE = "/admin/v1/coupons-v2";

// ── List ──────────────────────────────────────────────────────────────────────
export const fetchCouponsV2Api = async (params = {}) => {
  const query = new URLSearchParams({ ...params }).toString();
  return await axios.get(`${BASE}?${query}`, setJwtToken());
};

// ── Single ────────────────────────────────────────────────────────────────────
export const fetchCouponV2ByIdApi = async (id) => {
  return await axios.get(`${BASE}/${id}`, setJwtToken());
};

// ── Create ────────────────────────────────────────────────────────────────────
export const createCouponV2Api = async (data) => {
  return await axios.post(BASE, data, setJwtToken());
};

// ── Update ────────────────────────────────────────────────────────────────────
export const updateCouponV2Api = async (id, data) => {
  return await axios.put(`${BASE}/${id}`, data, setJwtToken());
};

// ── Deactivate ────────────────────────────────────────────────────────────────
export const deleteCouponV2Api = async (id) => {
  return await axios.delete(`${BASE}/${id}`, setJwtToken());
};

// ── Validate (admin test) ─────────────────────────────────────────────────────
export const validateCouponV2Api = async (data) => {
  return await axios.post(`${BASE}/validate`, data, setJwtToken());
};

// ── Redemption logs ───────────────────────────────────────────────────────────
export const fetchRedemptionLogsApi = async (params = {}) => {
  const query = new URLSearchParams({ ...params }).toString();
  return await axios.get(`${BASE}/redemption-logs?${query}`, setJwtToken());
};

export const fetchRedemptionLogsSummaryApi = async (params = {}) => {
  const query = new URLSearchParams({ ...params }).toString();
  return await axios.get(`${BASE}/redemption-logs/summary?${query}`, setJwtToken());
};
